module.exports = __webpack_public_path__ + "static/media/burkina-faso.2db515f3.png";